export const zIndex = {
    overLinkOverlay: {
        value: 1,
    },
    overMap: {
        value: 2,
    },
    overMapMarkers: {
        value: 10000,
    },
    toast: {
        value: 2000000000,
    },
};
